// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1-VFG","requiredAsterisk":"Info_requiredAsterisk__1zNVv"};